// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"9f19eeb6","118":"09ba5388","717":"038ff846"}[chunkId] + ".js";
};